import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import { Button, Text, Title } from "@runwayhealth/runway-components-react";

interface RemoveMedicationDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  /** Whether a save or payment is in progress. Closing is ignored while it is. */
  isBusy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const titleId = "remove-medication-dialog-title";
const descriptionId = "remove-medication-dialog-description";

export const RemoveMedicationDialog = ({
  isOpen,
  title,
  message,
  isBusy,
  onCancel,
  onConfirm,
}: RemoveMedicationDialogProps) => (
  <Modal
    open={isOpen}
    className="remove-medication-modal"
    BackdropComponent={Backdrop}
    BackdropProps={{ timeout: 500, className: "remove-medication-backdrop" }}
    closeAfterTransition
    onClose={() => {
      if (!isBusy) onCancel();
    }}
  >
    <Fade in={isOpen}>
      <div
        className="remove-medication-paper"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={descriptionId}
      >
        <div className="remove-medication-text">
          <div id={titleId}>
            <Title as="h2" size="lg">
              {title}
            </Title>
          </div>
          <div id={descriptionId}>
            <Text>{message}</Text>
          </div>
        </div>
        <div className="remove-medication-actions">
          <Button size="md" variant="outline" customWidth={180} isBlock onClick={onCancel}>
            Cancel
          </Button>
          <Button
            size="md"
            variant="primary"
            customWidth={180}
            isBlock
            aria-disabled={isBusy}
            onClick={() => {
              if (!isBusy) onConfirm();
            }}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Fade>
  </Modal>
);
